import React, { useState } from "react";
import { Grid, Typography, TextField } from "@mui/material";
import { DatePicker } from "antd";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import SearchIcon from "@mui/icons-material/Search";
// import DateRangeIcon from "@mui/icons-material/DateRange";

const { RangePicker } = DatePicker;

const SearchBar = ({
  visibleColumns,
  searchTerm,
  handleSearchChange,
  handleClear,
  columns,
  QRCode,
  searchAll,
}) => {
  const [filters, setFilters] = useState(
    visibleColumns.length > 0
      ? visibleColumns.reduce(
          (acc, column) => ({ ...acc, [column.accessor]: "" }),
          {}
        )
      : { search: "" } // กรณีไม่มี visibleColumns, ให้สร้าง field search ทั่วไป
  );
  const [dates, setDates] = useState([null, null]);

  // ฟังก์ชันจัดการการเปลี่ยนแปลงของ input
  const handleInputChange = (accessor, value) => {
    if (!accessor) {
      console.error("Accessor is undefined or null");
      return;
    }
    setFilters((prev) => ({ ...prev, [accessor]: value || "" }));
  };

  const handleSearchClickInternal = () => {
    // console.log(filters); // Debugging line to check filters object
    const validFilters = visibleColumns.length
      ? visibleColumns.reduce((acc, column) => {
          const value =
            filters[column.accessor] !== undefined
              ? filters[column.accessor]
              : "";
          acc[column.accessor] = value;
          return acc;
        }, {})
      : { search: filters.search }; // หากไม่มี visibleColumns ใช้ `search` ทั่วไป

    handleSearchChange(validFilters); // ส่งค่า filter ไปให้ handleSearchChange
    searchTerm(validFilters); // ส่งค่า filter ไปให้ searchTerm
  };

  // ฟังก์ชันจัดการการคลิกปุ่ม Clear
  const handleClearClick = () => {
    setFilters(
      visibleColumns.length
        ? columns.reduce(
            (acc, column) => ({ ...acc, [column.accessor]: "" }),
            {}
          )
        : { search: "" } // รีเซ็ตฟิลด์ search
    );
    setDates([null, null]);
    handleClear();
  };

  // การจัดกลุ่มฟิลด์ให้แสดงในหลายๆ แถว
  let groupedFields = [];
  if (visibleColumns.length <= 4 || visibleColumns.length === 0) {
    groupedFields.push(
      visibleColumns.length && searchAll
        ? [...visibleColumns, { Header: "ค้นหาทั้งหมด", accessor: "search" }]
        : visibleColumns.length
        ? visibleColumns
        : [{ Header: "ค้นหาทั้งหมด", accessor: "search" }]
    );
  } else {
    for (let i = 0; i < visibleColumns.length; i += 3) {
      groupedFields.push(visibleColumns.slice(i, i + 3));
    }
  }

  const renderFieldGroup = (group, groupIdx, filters, handleInputChange) => (
    <Grid
      container
      item
      xs={12}
      spacing={2}
      key={groupIdx}
      justifyContent={"flex-start"}
    >
      {group.map((field, idx) => (
        // console.log("group5555", group),
        <Grid
          item
          xs={12}
          sm={4}
          md={4}
          key={idx}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Typography
            sx={{
              whiteSpace: "nowrap",
              marginRight: "8px",
              textAlign: "right",
              width: "120px", // Ensure header width stays consistent
              flexShrink: 0, // Prevent shrinking
            }}
          >
            {field.Header.includes("วันที่") ? "วันที่" : field.Header}
          </Typography>

          {field.type === "date" ? (
            <RangePicker
              value={filters[field.accessor] || null}
              onChange={(dates) => handleInputChange(field.accessor, dates)}
              style={{
                width: "100%", // Make RangePicker use full width
              }}
              placeholder={["Start Date", "End Date"]}
            />
          ) : (
            <TextField
              variant="outlined"
              placeholder={field.placeholder || "Search"}
              value={filters[field.accessor] || ""}
              onChange={(e) =>
                handleInputChange(field.accessor, e.target.value)
              }
              fullWidth
              InputProps={{
                sx: {
                  bgcolor: "white",
                  borderRadius: "4px",
                  width: "100%",
                  height: "40px",
                },
              }}
              sx={{
                flexGrow: 1, // Ensure TextField expands to fill available space
                width: group.length === 5 ? "370px" : "100%", // Adjust width based on group length
              }}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );

  const renderFieldSomeGroup = (
    group,
    groupIdx,
    filters,
    handleInputChange
  ) => {
    return (
      <Grid
        container
        item
        xs={12}
        spacing={2}
        key={groupIdx}
        alignItems="center"
        justifyContent={"space-between"}
      >
        {/* QR Code Button at the far left */}
        {QRCode && (
          <Grid item>
            <GradientButtonOutline variant="outlined">
              QR Code
            </GradientButtonOutline>
          </Grid>
        )}

        {/* Render fields */}
        {group.map((field, idx) => (
          <Grid
            container
            item
            xs={12}
            sm={group.length <= 2 ? 6 : 4}
            md={group.length <= 2 ? 6 : 4}
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
            }}
            spacing={1}
          >
            {/* Field Header */}
            <Grid item>
              <Typography
                sx={{
                  whiteSpace: "nowrap",
                  marginRight: "8px",
                  textAlign: "right",
                  width: "120px",
                }}
              >
                {field.Header}
              </Typography>
            </Grid>

            {/* Field Input */}
            <Grid item xs>
              {field.type === "date" ? (
                <RangePicker
                  value={filters[field.accessor] || null}
                  onChange={(dates) => handleInputChange(field.accessor, dates)}
                  style={{ width: "100%" }}
                  placeholder={["Start Date", "End Date"]}
                />
              ) : (
                <TextField
                  variant="outlined"
                  placeholder={field.placeholder || "Search"}
                  value={filters[field.accessor] || ""}
                  onChange={(e) =>
                    handleInputChange(field.accessor, e.target.value)
                  }
                  fullWidth
                  InputProps={{
                    sx: {
                      bgcolor: "white",
                      borderRadius: "4px",
                      height: "40px",
                    },
                  }}
                  sx={{
                    width: group.length === 5 ? "370px" : "100%",
                  }}
                />
              )}
            </Grid>

            {/* Buttons for Clear and Search */}
            <Grid item>
              <Grid container spacing={1}>
                <Grid item>
                  <GradientButtonOutline
                    variant="outlined"
                    onClick={handleClearClick}
                  >
                    ล้าง
                  </GradientButtonOutline>
                </Grid>
                <Grid item>
                  <GradientButton
                    variant="contained"
                    color="primary"
                    onClick={handleSearchClickInternal}
                  >
                    <Typography>ค้นหา</Typography>
                    <SearchIcon />
                  </GradientButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    );
  };

  const renderButtons = (
    QRCode,
    handleClearClick,
    handleSearchClickInternal
  ) => (
    <Grid
      container
      item
      xs={12}
      sm={12}
      md={12}
      justifyContent="space-between"
      alignItems="center"
      spacing={2}
    >
      {QRCode && (
        <Grid item>
          <GradientButtonOutline variant="outlined">
            QR Code
          </GradientButtonOutline>
        </Grid>
      )}
      <Grid item>
        <Grid container spacing={2}>
          <Grid item>
            <GradientButtonOutline
              variant="outlined"
              onClick={handleClearClick}
            >
              ล้าง
            </GradientButtonOutline>
          </Grid>
          <Grid item>
            <GradientButton
              variant="contained"
              color="primary"
              onClick={handleSearchClickInternal}
            >
              <Typography>ค้นหา</Typography>
              <SearchIcon />
            </GradientButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );

  return (
    <Grid container spacing={2} alignItems="center">
      {groupedFields.map((group, groupIdx) => {
        const accessor = group[0]?.accessor; // เข้าถึง accessor ในออบเจกต์แรกของ group
        // console.log("group accessor", accessor);

        return accessor === "search"
          ? renderFieldSomeGroup(group, groupIdx, filters, handleInputChange)
          : renderFieldGroup(group, groupIdx, filters, handleInputChange);
      })}

      {/* แสดงปุ่ม QR Code, Clear, และ Search เพียงครั้งเดียว */}
      {groupedFields.some((group) => group[0]?.accessor !== "search") &&
        renderButtons(QRCode, handleClearClick, handleSearchClickInternal)}
    </Grid>
  );
};

export default SearchBar;
